import {SxProps, Theme} from '@mui/material';
import {Color} from '~/constants/style';

export const backButtonStyles: SxProps<Theme> = {
  marginBottom: '12px',
  maxWidth: '80px',
  width: '100%',
  lineHeight: '22px',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 400,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: Color.Purple600,
  '&:hover': {
    backgroundColor: Color.BackButtonBackground,
  },
};
